import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PageTitlesService } from '../../../services/page-titles.service';
import navIcon from 'src/assets/toggle-navigation.svg';

@Component({
  selector: 's-ori-header',
  templateUrl: './ori-header.component.html',
  styleUrls: ['./ori-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ORIHeaderComponent implements OnInit {
  public pageTitle$: Observable<string>;
  @Input()
  public isAuthorized: boolean;

  @Input()
  public userName: string;

  @Input()
  public userPosition: string;

  @Input()
  public userAvatar: string;

  @Output()
  public toggleNavigation: EventEmitter<void> = new EventEmitter<void>();

  public navIcon = navIcon;

  constructor(
    private titles: PageTitlesService
  ) {
  }

  public ngOnInit() {
    this.pageTitle$ = this.titles.titlesUpdates$.pipe(map(value => value.pageTitle));
  }

}
